/*
 * wallpaper-buybox.js — product-page buy-box behavior for pattern/mural products.
 *
 * Why this file exists:
 *   The inline <script> in snippets/product-buttons-wallpaper.liquid is truncated /
 *   corrupted at render time (a stray </script> / inlined JSON breaks the tag), so the
 *   buy-box handlers defined there never run. That left BOTH "Get Started" and
 *   "Preview & Show Price" dead — there was no working way to reach the editor on a
 *   pattern/mural product. An external asset is immune to that inline-render corruption.
 *
 * What it does:
 *   - "Preview & Show Price" (#preview-show-price-btn / [data-bb-preview]):
 *       validate the wall-size inputs -> (logged-out, once/session) show the
 *       account-save-modal sign-in/sign-up popup -> reveal the editor (configurator)
 *       with the entered dimensions carried in and the price calculated.
 *   - "Get Started" (#launch-configurator-btn): same reveal, gated the same way
 *       (fallback path; on pattern/mural this button is visually hidden).
 *   - The popup is a SOFT, once-per-session gate (matches the existing
 *       account-save-modal used on Add to Cart): logged-in shoppers and shoppers who
 *       have already seen it this session go straight to the editor.
 *   - "Sign in with Shop" redirects away; we persist the intent + dimensions so the
 *       editor auto-opens when the shopper returns logged in.
 */
(function () {
  if (window.__wallpaperBuyboxBound) return;
  window.__wallpaperBuyboxBound = true;

  var PENDING_FLAG = 'bb_pending_open_editor';
  var PENDING_DIMS = 'bb_pending_dims';

  function $(id) { return document.getElementById(id); }
  function num(el) { var v = parseFloat(el && el.value); return isNaN(v) ? 0 : v; }

  function isLoggedIn() {
    return document.body.classList.contains('customer-logged-in') ||
      (document.body.dataset && document.body.dataset.customer === 'logged-in') ||
      document.documentElement.classList.contains('customer-logged-in');
  }

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* noop */ } }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) { /* noop */ } }

  // ---- Reveal the editor (replicates the old showConfigurator) ----
  function revealEditor() {
    var wrap = $('configurator-wrapper');
    if (!wrap) return;
    var main = document.querySelector('main') || document.querySelector('[role="main"]');
    if (main) {
      main.querySelectorAll('section, .shopify-section').forEach(function (s) {
        if (!s.contains(wrap)) s.style.display = 'none';
      });
    }
    wrap.style.display = 'block';
    window.scrollTo(0, 0);

    // Persist the buy-box's currently selected material/variant so the configurator
    // prices it on init. Without this the editor opens at $0.00 (sqft is known but
    // there is no material/price). Must be set BEFORE init() reads it.
    try {
      var launchBtn = $('launch-configurator-btn');
      var pid = launchBtn && launchBtn.getAttribute('data-product-id');
      var pform = document.querySelector('[data-product-form]');
      var vidInput = pform && pform.querySelector('[name="id"]');
      var vid = vidInput && vidInput.value;
      if (pid && vid) sessionStorage.setItem('configurator_variant_' + pid, vid);
    } catch (e) { /* noop */ }

    var wc = document.querySelector('wallpaper-configurator');
    try {
      if (wc && wc.state && !wc.state.initialized && typeof wc.init === 'function') wc.init();
    } catch (e) { /* noop */ }
    if (typeof window.reinitWallpaperConfigurator === 'function') {
      setTimeout(function () { try { window.reinitWallpaperConfigurator(); } catch (e) {} }, 100);
    }
  }

  // Copy the wall-size card values into the configurator's dimension inputs and fire
  // input/change so the configurator recalculates area + price.
  function pushDimensions() {
    var map = [
      ['width-feet', 'bb-width-feet'],
      ['width-inches', 'bb-width-inches'],
      ['height-feet', 'bb-height-feet'],
      ['height-inches', 'bb-height-inches']
    ];
    map.forEach(function (pair) {
      var target = $(pair[0]);
      var src = $(pair[1]);
      if (!target || !src) return;
      target.value = num(src);
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function revealAndPush() {
    revealEditor();
    // Push after the configurator's listeners attach; re-assert once more after the
    // async image-load/init settles (murals momentarily reset the summary to $0).
    requestAnimationFrame(function () {
      setTimeout(function () {
        pushDimensions();
        var price = $('summary-price') || document.querySelector('.summary-card');
        if (price) price.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 150);
      setTimeout(pushDimensions, 600);
    });
  }

  // ---- Sign-in/up gate (soft, once per session) ----
  function gateThen(cb) {
    if (isLoggedIn()) { cb(); return; }
    var asm = window.AccountSaveModal;
    if (asm && typeof asm.open === 'function' && typeof asm.shouldShow === 'function' && asm.shouldShow()) {
      asm.open().then(function () {
        // "Sign in with Shop" sets this flag then redirects; don't reveal now — the
        // editor will auto-open on return (see resumeAfterLogin). Otherwise (email /
        // skip / close) proceed straight into the editor.
        if (ssGet('asm_shop_login_pending') === '1') return;
        ssDel(PENDING_FLAG);
        cb();
      });
    } else {
      ssDel(PENDING_FLAG);
      cb();
    }
  }

  // ---- Validation ----
  function clearInvalid(els) {
    els.forEach(function (el) { if (el) el.classList.remove('bb-wallsize__input--invalid'); });
  }
  function validateDims() {
    var wf = $('bb-width-feet'), wi = $('bb-width-inches'), hf = $('bb-height-feet'), hi = $('bb-height-inches');
    clearInvalid([wf, wi, hf, hi]);
    var w = num(wf) * 12 + num(wi);
    var h = num(hf) * 12 + num(hi);
    var ok = true;
    if (w <= 0) { if (wf) wf.classList.add('bb-wallsize__input--invalid'); if (wi) wi.classList.add('bb-wallsize__input--invalid'); ok = false; }
    if (h <= 0) { if (hf) hf.classList.add('bb-wallsize__input--invalid'); if (hi) hi.classList.add('bb-wallsize__input--invalid'); ok = false; }
    if (!ok) { var f = wf || hf; if (f) f.focus({ preventScroll: true }); }
    return ok;
  }

  // ---- Handlers ----
  function onPreview(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!validateDims()) return;
    // Persist intent + dims so a "Sign in with Shop" redirect can resume into the editor.
    ssSet(PENDING_FLAG, '1');
    ssSet(PENDING_DIMS, JSON.stringify({
      wf: num($('bb-width-feet')), wi: num($('bb-width-inches')),
      hf: num($('bb-height-feet')), hi: num($('bb-height-inches'))
    }));
    gateThen(revealAndPush);
  }

  function onLaunch(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    ssSet(PENDING_FLAG, '1');
    gateThen(revealAndPush);
  }

  // After a "Sign in with Shop" redirect returns the shopper to the product page,
  // auto-open the editor with the dimensions they had entered.
  function resumeAfterLogin() {
    if (ssGet(PENDING_FLAG) !== '1') return;
    if (!$('configurator-wrapper')) return;
    ssDel(PENDING_FLAG);
    var dims = null;
    try { dims = JSON.parse(ssGet(PENDING_DIMS) || 'null'); } catch (e) { /* noop */ }
    ssDel(PENDING_DIMS);
    if (dims) {
      var s = function (id, v) { var el = $(id); if (el) el.value = v; };
      s('bb-width-feet', dims.wf); s('bb-width-inches', dims.wi);
      s('bb-height-feet', dims.hf); s('bb-height-inches', dims.hi);
    }
    revealAndPush();
  }

  // ---- Sample vs Custom button toggle ----
  // Selecting the "Sample" size should show the regular Add-to-Cart and hide the
  // wall-size card; any other (Custom) size shows the wall-size card and hides the
  // regular ATC. (Pipeline already updates the form's variant id + URL on change;
  // only this show/hide swap was lost with the corrupted inline script.)
  function isSampleSelected() {
    var checked = document.querySelectorAll('input[type="radio"][name^="options"]:checked');
    for (var i = 0; i < checked.length; i++) {
      if ((checked[i].value || '').toLowerCase().indexOf('sample') !== -1) return true;
      var label = checked[i].closest('label');
      if (label && (label.textContent || '').toLowerCase().indexOf('sample') !== -1) return true;
    }
    var popouts = document.querySelectorAll('input[data-popout-input][name^="options"]');
    for (var j = 0; j < popouts.length; j++) {
      if ((popouts[j].value || '').toLowerCase().indexOf('sample') !== -1) return true;
    }
    return false;
  }

  function toggleButtons() {
    var sample = isSampleSelected();
    var regular = $('regular-cart-buttons');
    var custom = $('custom-size-button');
    var card = $('bb-wallsize-card');
    if (regular) regular.style.display = sample ? 'block' : 'none';
    if (custom) custom.style.display = sample ? 'none' : 'block';
    if (card) card.style.display = sample ? 'none' : '';
  }

  function bind() {
    var preview = $('preview-show-price-btn');
    if (preview && !preview.__bbBound) { preview.__bbBound = true; preview.addEventListener('click', onPreview); }
    var launch = $('launch-configurator-btn');
    if (launch && !launch.__bbBound) { launch.__bbBound = true; launch.addEventListener('click', onLaunch); }
    // Attach the variant-change listeners once.
    if (!window.__bbToggleListeners) {
      window.__bbToggleListeners = true;
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('[name^="options"]')) {
          setTimeout(toggleButtons, 0);
        }
      });
      document.addEventListener('theme:variant:change', function () { toggleButtons(); });
    }
    toggleButtons();
    resumeAfterLogin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  // Re-run once in case the buy box renders slightly late.
  setTimeout(bind, 500);
})();
